import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React from 'react';
import { IndicatorContainer, splitContainerProps } from '../../internal';
import { withRef } from '../../utils';
let idCount = 0;
export const Radio = withRef(function Radio({ id = `castor_radio_${++idCount}`, bordered, invalid, children, className, style, ...restProps }, ref) {
    const { disabled, touched } = useField();
    const [containerProps, inputProps] = splitContainerProps(restProps);
    return (React.createElement(IndicatorContainer, { ...containerProps, htmlFor: id, bordered: bordered, className: className, style: style }, {
        children,
        input: (React.createElement("input", { disabled: disabled, ...inputProps, ref: ref, id: id, type: "radio", className: classy(c('radio'), m({ invalid, touched })) })),
    }));
});
//# sourceMappingURL=radio.js.map